import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pen-draw-gay",
  "use": "icon-pen-draw-gay-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-pen-draw-gay\"><path d=\"M574.11 225.57L799.14 450.6 310.5 939.24l-200.63 22.15c-26.86 2.97-49.55-19.74-46.56-46.6l22.32-200.77 488.48-488.45z m364.21-33.5L832.66 86.41c-32.96-32.96-86.41-32.96-119.37 0l-99.4 99.4 225.03 225.03 99.4-99.4c32.96-32.98 32.96-86.41 0-119.37z\" p-id=\"8823\" fill=\"#707070\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol